export default String.raw`
.footer {
    background-color: $footerColorBackground;
    font-size: 16px;
    line-height: 20px;
    padding: 32px 130px;
    
    &__wrapper {
      max-width: 1440px;
      width: 100%;
      margin: 0 auto;
    }

    &__main {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(215px, 1fr));
        gap: 24px;
        &.more-columns {
            grid-template-columns: repeat(5, minmax(215px, 1fr));
        }
    }

    &__section {
        max-width: 215px;

        &.contact-section {
            max-width: 215px;
            grid-column: 5 / span 1;
            grid-row: 1;
            justify-self: end;
        }

        &-title {
            font-weight: 600;
            color: $footerColorFont;
            letter-spacing: 0.67px;
            word-break: break-all;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
        }

        &-arrow {
            display: none;
        }

        &-link, &-link a, &-info a {
            font-size: 12px;
            font-weight: 500;
            line-height: 16px;
        }
        
        &-link {
            margin: 12px 0;
            word-break: break-word;
            &:first-child {
                margin-top: 16px;
            }
        }
        
        &-info {
            margin: 20px 0;
            display: flex;
            align-items: center;
            &:last-child {
                margin-bottom: 24px;
            }
        }

        &-link a, &-info a {
            color: $footerColorLinks;
        }

        &-social {
            margin-top: 16px;
            display: flex;
            flex-wrap: wrap;
            column-gap: 16px;
            row-gap: 8px;
            img {
                max-width: 24px;
                max-height: 24px;
            }
        }
    }

    &__icon {
        fill: $footerColorLinks;
        margin-right: 8px;
    }

    &__banners {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-top: 20px;
    }

    &__banner {
        margin: 16px 0 8px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        &-title {
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
            color: $footerColorLinks;
            margin-right: 16px;
        }
        &-content {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
        }
        &-img, &-img img {
            max-width: 64px;
            max-height: 32px;
        }
        &-img {
            background-color: $footerBannerBackground;
            border-radius: 4px;
            margin-right: 16px;
            display: flex;
            justify-content: center;
            align-items: center;
            &:last-child {
                margin-right: 32px;
            }
        }
    }
    
    &__copyright {
        width: 100%;
        border-top: 1px solid $footerColorFont;
        padding-top: 24px;
        &-content {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            p, a {
                color: $footerColorLinks;
                margin: 0;
                font-size: 10px;
                font-weight: 400;
                line-height: 16px;
            }
        }
    }  
}
`